import React from 'react';

import { Wrapper } from './Block.jsx';
import { EmptyPlaceholder } from '../utility/blocks';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

import { default as ClickToken } from '../../../../../artcloud.click/source/scripts/common/Token.jsx';

function RecipientMetaComponent(props) {
    const _data = (props) => {
        let data = props.data || {};
        if (data.Recipient) {
            data = data.Recipient;
        }
        return data;
    }
    const parseContent = (props, tokenizedString) => {
        if (!tokenizedString) {
            return '';
        }
        // const data = props.data || {};
        const data = _data(props);
        return ClickToken.parseTokenizedString(tokenizedString, (keyword, options) => {
            let replaceString = '';
            switch (keyword) {
                case Token.Company:
                    if (data.Company && data.Company.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.Company, options);
                    }
                    break;
                case Token.Contact.Email:
                    if (data.Email && data.Email.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.Email, options);
                    }
                    break;
                case Token.Contact.EmailLink:
                    if (data.Email && data.Email.length > 0) {
                        let display = data.Email;
                        if (options && options.display && options.display.length > 0) {
                            display = options.display;
                        }
                        replaceString = `<a href="mailto:${data.Email}" style="color:inherit;">${display}</a>`;
                    }
                    break;
                case Token.Contact.Name:
                    if (data.Name && data.Name.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.Name, options);
                    }
                    break;
                case Token.Contact.Phone:
                    if (data.Phone && data.Phone.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.Phone, options);
                    }
                    break;
                default:
                    replaceString = undefined;
                    break;
            }
            if (replaceString == '' && options && options.default && options.default.length > 0) {
                replaceString = options.default;
                if (replaceString.trim().length == 0) {
                    replaceString = '&nbsp;'
                }
            }
            return replaceString;
        });
    }
    const data = _data(props);
    const design = props.blockConfig && props.blockConfig.block && props.blockConfig.block.design;
    const [content, setContent] = React.useState(undefined);
    React.useEffect(() => {
        setContent(parseContent(props, props.blockConfig.block.design));
    }, [design]);

    if (props.serverSide && content == undefined) {
        setContent(parseContent(props, props.blockConfig.block.design));
    }
    if (!props.builder && content != undefined && content.length == 0) {
        return null;
    }
    const { contentContainerStyle, contentStyle, innerStyle, wrapperStyle} = Utilities.parseTextWrapperConfig(props.blockConfig);
    return (
        <Wrapper {...props} className="SharedCaptionBlock" style={wrapperStyle}>
            <td align="center" className="SharedCaptionBlockInner" style={innerStyle} valign="top">
                <table
                    align="center"
                    border="0"
                    cellPadding="0"
                    cellSpacing="0"
                    className="SharedCaptionBottomContent"
                    style={contentContainerStyle}
                    width={props.maxWidth}>
                    <tbody>
                        <tr>
                            <td
                                className="SharedTextContent"
                                style={contentStyle}
                                valign="middle">
                                {
                                    content != undefined &&
                                    <div dangerouslySetInnerHTML={{ __html: content }} style={{ lineHeight: 1 }} />
                                }
                                {
                                    props.builder &&
                                    (content == undefined || content.length == 0) &&
                                    <EmptyPlaceholder fullWidth={true} />
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </Wrapper>
    );
}
const RecipientMetaTokens = () => {
    return [
        Token.getWrappedTokenConfig('Company', Token.Company, false),
        Token.getWrappedTokenConfig('Name', Token.Contact.Name, false),
        Token.getWrappedTokenConfig('Email', Token.Contact.Email, false),
        Token.getDisplayTokenConfig('Email Link', Token.Contact.EmailLink),
        Token.getWrappedTokenConfig('Phone', Token.Contact.Phone, false)
    ];
}
const RecipientMetaTypeConfig = {
    defaultDesign: `<p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Company}">{${Token.Company}("before":"","after":"")}</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Contact.Name}">{${Token.Contact.Name}("before":"","after":"")}</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Contact.Email}">{${Token.Contact.Email}("before":"","after":"")}</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Contact.Phone}">{${Token.Contact.Phone}("before":"","after":"")}</span></p>`,
    panel: {
        block: function () {
            const group = 'block';
            return {
                group,
                label: 'Content',
                options: [
                    {
                        display: 'Design recipient meta here',
                        group,
                        name: 'design',
                        type: 'rich-text-campaign-short',
                        value: RecipientMetaTypeConfig.defaultDesign
                    },
                    {
                        display: 'Background Color',
                        group,
                        name: 'backgroundColor',
                        type: 'color'
                    },
                    {
                        display: 'Content Background Color',
                        group,
                        name: 'contentColor',
                        type: 'color'
                    },
                    {
                        display: 'Border Radius',
                        group,
                        name: 'borderRadius',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: TypeConfig.options.measurement(),
                        type: 'border'
                    }
                ]
            };
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        disabled: ['marginLeft', 'marginRight', 'marginBottom', 'marginTop'],
                        display: 'Padding/Margin',
                        group,
                        max: '100',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '9', unit: 'px' },
                            paddingTop: { value: '9', unit: 'px' }
                        }
                    }
                ]
            };
        }
    }
}
const RecipientMetaBlockTypeDefinition = (group) => {
    return {
        id: Name.Block.Recipient.Text,
        config: {
            block: RecipientMetaTypeConfig.panel.block(),
            layout: RecipientMetaTypeConfig.panel.layout()
        },
        display: 'Recipient Meta Text',
        group,
        image: 'recipient_meta_text.png'
    };
}
export { RecipientMetaBlockTypeDefinition, RecipientMetaComponent, RecipientMetaTokens, RecipientMetaTypeConfig }